module.exports = __webpack_public_path__ + "static/media/asteroidTexture.156214f0.jpg";